import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-textarea',
  template: `
    <p-divider
      *ngIf="
        props && props.attributes && props.attributes['separator']
      "
    ></p-divider>
    <div class="field p-fluid mb-3 mt-1">
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label class="block">{{ field.templateOptions.label }}</label>
      <textarea
        pInputTextarea
        rows="5"
        [formControl]="control"
        [formlyAttributes]="field"
      ></textarea>
      <div
        *ngIf="showError && formControl.errors"
        class="text-sm mt-2 p-error"
      >
        <formly-validation-message
          [field]="field"
        ></formly-validation-message>
      </div>
      <div
        *ngIf="
          field.templateOptions.description &&
          (!showError || !formControl.errors)
        "
        class="text-sm mt-2"
      >
        {{ field.templateOptions.description }}
      </div>
      <div
        *ngIf="
          props && props.attributes && props.attributes['warning']
        "
        class="text-sm my-1 text-yellow-400"
      >
        <span
          class="font-bold"
          i18n
          >Warnung:</span
        >
        {{ props.attributes['warning'] }}
      </div>
    </div>
  `,
})
export class TextareaTypeComponent extends FieldType {
  get control() {
    return this.formControl as FormControl;
  }
}
